import {Injectable} from "@angular/core";
import {SearchController} from "@app/ui_controllers/searchController";
import {TextSearchController} from "@app/ui_controllers/textSearchController";
import {HttpParams} from "@angular/common/http";
import {TextSearchDto} from "@app/ui_models/web-response";
import {VirtualScroller, VirtualScrollerLazyLoadEvent} from "primeng/virtualscroller";
import {Observable} from "rxjs";

@Injectable({ providedIn: "root" })
export class SearchService {

  constructor(private searchController: SearchController, private textSearchController: TextSearchController) {}

  public searchTerm = ""
  public searchInProgress = false;
  public quickSearchResults: string[] = [];
  public searchResults: { label: string; value: string; items: any[]; }[] = [];
  public content: TextSearchDto[] = [];
  public contentChunked: TextSearchDto[] [] = []
  public pageSize: number = 90;
  page: number = 0;
  totalRows: number = 0;


  public quickSearch(query: string): any {
    this.searchTerm = query;
    this.quickSearchResults = ["Шукаю..."];
    this.searchInProgress = true;
    // return this.searchController.quickSearch(query).subscribe(data => {
    //   this.quickSearchResults = this.mapResponse(data);;
    //   this.searchInProgress = false;
    // });
    this.textSearchController.getSuggestions(query, 10).subscribe(data => {
      this.quickSearchResults = data;
      this.searchInProgress = false
    })
  }

  search(event?: VirtualScrollerLazyLoadEvent, vs?: VirtualScroller): Observable<any> {
    if (!this.searchTerm) {
      return new Observable();
    }
    let params = new HttpParams();
    const sortFieldAndOrder = "username, ASC";
    params = params.append("sort", sortFieldAndOrder);
    params = params.append("page", this.page);
    params = params.append("size", this.pageSize);
    params = params.append("query", this.searchTerm);
    this.searchInProgress = true;
    if (event && vs) {
      return this.textSearchController.textSearch(params)
    } else {
      this.textSearchController.textSearch(params).subscribe(data => {
        // this.searchResults = this.mapResponse(data);;
        this.content.push(...this.splitByChunks(data.content));
        this.totalRows = data.totalElements;
        this.searchInProgress = false;
        if (event?.forceUpdate) {
          console.log("Callback invoked")
          event.forceUpdate();
        }
        setTimeout(() => {
          if (vs?.scrollToIndex) {
            console.log("scrollToIndex")
            vs.scrollToIndex(10, "smooth");
          }
        }, 1000)
      });
      return new Observable();
    }
  }

  public splitByChunks(dtos: TextSearchDto[]): any []{
    let retValue: any[] = []
    const chunkSize = 3;
    for (let i = 0; i < dtos.length; i += chunkSize) {
      const chunk = dtos.slice(i, i + chunkSize);
      retValue.push(chunk)
    }
    return retValue;
  }



  // public filter(query: string) {
  //   let value: any [] = this.searchResults
  //     .filter(item => item.label.toLowerCase().includes(query.toLowerCase()));
  //   if (value.length !== 0) {
  //     return value[0].items;
  //   } else {
  //     return [];
  //   }
  // }
}
